import React from "react";

const Heading = ({ variant, children, className }) => {
  return (
    <>
      {/* o	Usage: Main titles on landing pages and primary headers. */}
      {variant === "h1" && (
        <h1
          className={`
          ${className} page-heading font-inter uppercase text-offblack`}
        >
          {children}
        </h1>
      )}

      {/* o	Usage: Titles for main sections. */}
      {variant === "h2" && (
        <h2
          className={`
          ${className} secondary-heading font-inter`}
        >
          {children}
        </h2>
      )}

      {/* o	Usage: Titles for subsections. */}
      {variant === "h3" && (
        <h3
          className={`
         ${className} tertiary-heading font-inter text-offblack`}
        >
          {children}
        </h3>
      )}

      {/* o	Usage: Titles for smaller sections or categories. */}
      {variant === "h4" && (
        <h4
          className={`
         ${className} component-heading font-inter text-offblack`}
        >
          {children}
        </h4>
      )}

      {/* o	Usage: Titles within content or sidebar headings. */}
      {variant === "h5" && (
        <h5
          className={`
         ${className} widget-title font-inter`}
        >
          {children}
        </h5>
      )}
      {/* o	Usage: Least prominent headings, widget titles, captions. */}
      {variant === "h6" && (
        <h6
          className={`
         ${className} label-heading font-inter`}
        >
          {children}
        </h6>
      )}
    </>
  );
};
export default Heading;
